import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';
import { Person, AnagraficaDettaglioParameter } from '../../../models/person';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
const moment = _moment;

import { MY_DATE_FORMATS } from '../../../models/generic-filter';

@Component({
  selector: 'app-contribuente-anagrafica',
  templateUrl: './contribuente-anagrafica.component.html',
  styleUrls: ['./contribuente-anagrafica.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS},
  ],
})
export class ContribuenteAnagraficaComponent{
  @Input() anagraficaDettaglioParameter: AnagraficaDettaglioParameter;
  @Output() idPersonEmitter = new EventEmitter<any>();
  @Output() innerEvents = new EventEmitter<any>();

  idPerson: number = 0;
  idPersonView: any = null;
  anagraficaSize: string;
  writePermission: boolean = false;
  editable: boolean = false;
  person = new Person();
  anagraficaSync: Subscription;
  anagraficaFormGroup: FormGroup;
  anagraficaMultiAccordion: boolean = false;

  constructor(private dataService: DataService, private adapter: DateAdapter<any>) {
    this.adapter.setLocale('it');
  }

  ngOnInit(){
    this.anagraficaFormGroup = new FormGroup({
      IDControl: new FormControl({ value: "", disabled: false, }),
      codiceFiscaleControl: new FormControl({ value: "", disabled: false, }),
      cognomeControl: new FormControl({ value: "", disabled: false, }),
      nomeControl: new FormControl({ value: "", disabled: false, }),
      indirizzoControl: new FormControl({ value: "", disabled: false, }),
      civicoControl: new FormControl({ value: "", disabled: false, }),
      capControl: new FormControl({ value: "", disabled: false, }),
      comuneControl: new FormControl({ value: "", disabled: false, }),
      provinciaControl: new FormControl({ value: "", disabled: false, }),
      telefonoControl: new FormControl({ value: "", disabled: false, }),
      emailControl: new FormControl({ value: "", disabled: false, }),
      nascitaDataControl: new FormControl({ value: moment(), disabled: false, }),
      nascitaLuogoControl: new FormControl({ value: "", disabled: false, }),
      nascitaProvinciaControl: new FormControl({ value: "", disabled: false, }),
      decessoDataControl: new FormControl({ value: moment(), disabled: false, }),
      ultimoAggiornamentoControl: new FormControl({ value: moment(), disabled: false, }),
    });

    this.anagraficaSync = this.dataService.getContribuentiService().anagrafica$.subscribe(
      anagrafica => {
        if(anagrafica && anagrafica.length){
          //console.log("CMP|CONTRIB-ANAGRAFICA - CHANGE ANAGRAFICA", anagrafica, this.idPerson, this.person);
          if(this.dataService.getUtentiService().getPermissions()){
            console.log("CMP|CONTRIB-ANAGRAFICA - personId:", this.idPerson);
            if(!this.idPerson || this.idPerson < 0){
              let idFirstPerson = this.dataService.getContribuentiService().getFirstAnagrafica();
              this.setIdPerson(idFirstPerson);
              console.log("CMP|CONTRIB-ANAGRAFICA - CHANGE ANAGRAFICA IDPERSON MIN", this.idPerson);
              this.idPersonEmitter.emit(this.idPerson);
            }
          }else{
            this.setIdPerson(this.dataService.getUtentiService().getUserIdAnagrafica());
          }
          this.checkIdPerson();
        }
      });
  }

  ngOnChanges(changes: any){
    console.log("CMP|CONTRIB-ANAGRAFICA - NGCHANGES", changes);
    if(changes.anagraficaDettaglioParameter){
      this.setIdPerson(this.anagraficaDettaglioParameter.idPerson);
      this.anagraficaSize = this.anagraficaDettaglioParameter.anagraficaSize;
      this.writePermission = this.anagraficaDettaglioParameter.writePermission;
      this.anagraficaMultiAccordion = (this.anagraficaSize == 'small') ? false : true;
      this.checkIdPerson();
      console.log("CMP|CONTRIB-ANAGRAFICA - NGCHANGES anagraficaDettaglioParameter", changes);
    }
  }

  setIdPerson(idPerson: any){
    console.log("CMP|CONTRIBUENTE-ANAGRAFICA - SETIDPERSON", idPerson);
    this.idPerson = idPerson;
    if(!isNaN(this.idPerson) && this.idPerson > 0){
      this.idPersonView = this.idPerson;
    }else{
      this.idPersonView = 'nuovo';
    }
  }

  checkIdPerson(){
    this.person = new Person(this.idPerson);
    if(!isNaN(this.idPerson)){
      if(this.idPerson > 0){
        this.dataService.getPersonById(this.idPerson, (person) => {
          if(person){
            this.person = person;
          }else{
            this.person = new Person(this.person.anagrafica_id);
          }
          //this.person.codice_fiscale = this.dataService.getUtentiService().getUserCf();
          //console.log("CMP|CONTRIB-ANAGRAFICA - cf", this.person.codice_fiscale);
        });
      }
    }
  }

  insert(){
    let localSets: any = this.person;
    this.dataService.insert("anagrafica", localSets, true, (error,res) => {
      if(error){
        //this.dataService.openMessage('INSERIMENTO ANAGRAFICA','si è verificato un errore');
      }
      if(res){
        console.log("CMP|CONTRIB-ANAGRAFICA - insert response:", res);
        this.setIdPerson(res);
        this.person.anagrafica_id = this.idPerson;
        /*if(res.data.success)
          res.newPerson = false;
        else
          res.newPerson = true;
        */
        let event: any = {
          hide : false,
          salvaContribuente:  true,
          title: "Anagrafica Dettaglio",
          subtitle: "Contribuente: " + this.idPerson
        }
        this.innerEvents.emit(event);
        this.idPersonEmitter.emit(this.idPerson);
      }
    });
  }

  update(){
    let value: any;
    let localFilters: any = [];
    localFilters.push({ type: "=", key: "codici_fiscali.id", value: this.idPerson });
    let localSets: any = {};

    Object.keys(this.person).map((key) => {
      value = Reflect.get(this.person, key);
      if(typeof value === 'string')
        Reflect.set(this.person, key, value.trim());
      if(typeof value === 'boolean')
        Reflect.set(this.person, key, (value ? -1 : 0));
    });
    localSets = this.person;
    console.log("CMP|CONTRIB-ANAGRAFICA - update anagrafica", localFilters, localSets);
    this.dataService.update("anagrafica", localFilters, localSets, true, (error,res) => {
      if(error){
        //this.dataService.openMessage('AGGIORNAMENTO ANAGRAFICA','si è verificato un errore');
      }
      if(res){
        console.log("CMP|CONTRIB-ANAGRAFICA - AGGIORNAMENTO ANAGRAFICA", res);
      }
    });
  }

  discard(){
    this.dataService.getPersonById(this.person.anagrafica_id,(person) => {
      if (person) {
        this.person = person;
      }
      else {
        this.person = new Person(this.person.anagrafica_id);
      }
    });
  }

  remove(){
    let localFilters = [];
    localFilters.push({ type: "=", key: "id", value: this.idPerson });

    this.dataService.delete("anagrafica", localFilters, true, (error,res) => {
      if(error){
        //this.dataService.openMessage('ELIMINAZIONE ANAGRAFICA','si è verificato un errore');
      }
      if(res){
        console.log("CMP|CONTRIB-ANAGRAFICA - ELIMINAZIONE ANAGRAFICA", res);
      }
    });
  }

  calcTabIndex(){
    if(this.idPerson && this.editable){
      return 0;
    }else{
      return -1;
    }
  }

  ngOnDestroy() {
    this.setIdPerson(0);
  }
}
